import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { PaginatorState } from "primeng/paginator";
import {
  catchError,
  combineLatest,
  finalize,
  of,
  startWith,
  Subject,
  switchMap,
  tap,
} from "rxjs";
import { InvitationsService } from "../../../services/invitations.service";
import { EventsInvitationsListComponent } from "./events-invitations-list/events-invitations-list.component";

@Component({
    selector: "app-events-invitations-tab-page",
    imports: [CommonModule, EventsInvitationsListComponent],
    templateUrl: "./events-invitations-tab-page.component.html",
    styleUrl: "./events-invitations-tab-page.component.scss"
})
export class EventsInvitationsTabPageComponent {
  private readonly invitationsService = inject(InvitationsService);

  private readonly page$ = new Subject<PaginatorState | undefined>();
  private readonly refreshInvitations$ = new Subject<void>();
  isLoading = false;

  myInvitations$ = combineLatest([
    this.page$.pipe(startWith(undefined)),
    this.refreshInvitations$.pipe(startWith(null)),
  ]).pipe(
    switchMap(([page]) =>
      this.invitationsService
        .getMyInvitations(page)
        .pipe(finalize(() => (this.isLoading = false))),
    ),
  );

  handleAcceptInvitationClick(invitation_id: number) {
    this.isLoading = true;
    this.invitationsService
      .acceptInvitation(invitation_id)
      .pipe(
        tap(() => this.refreshInvitations$.next()),
        catchError(() => {
          this.isLoading = false;
          return of(null);
        }),
      )
      .subscribe();
  }

  handleDeclineInvitationClick(invitation_id: number) {
    this.isLoading = true;
    this.invitationsService
      .declineInvitation(invitation_id)
      .pipe(
        tap(() => this.refreshInvitations$.next()),
        catchError(() => {
          this.isLoading = false;
          return of(null);
        }),
      )
      .subscribe();
  }

  handlePageChange(page: PaginatorState) {
    this.page$.next(page);
  }
}
